// GroupDialogContext.js
import { createContext, useContext, useReducer } from 'react'
import { DIALOG_KEYS } from '../constants'

const GroupDialogContext = createContext()

const initialState = {
  [DIALOG_KEYS.GROUP_ADD]: { open: false, isLoading: false, action: null },
  [DIALOG_KEYS.GROUP_DELETE]: { open: false, isLoading: false, action: null },
  [DIALOG_KEYS.GROUP_EDIT_NAME]: {
    open: false,
    isLoading: false,
    action: null,
  },
  [DIALOG_KEYS.SUB_GROUP_ADD]: { open: false, isLoading: false, action: null },
  [DIALOG_KEYS.SUB_GROUP_EDIT_NAME]: {
    open: false,
    isLoading: false,
    action: null,
  },
  [DIALOG_KEYS.SUB_GROUP_DELETE]: {
    open: false,
    isLoading: false,
    action: null,
  },
  [DIALOG_KEYS.DELETE_SUBSCRIBER_FROM_GROUP]: {
    open: false,
    isLoading: false,
    action: null,
  },
  [DIALOG_KEYS.ADD_SUBSCRIBER]: { open: false, isLoading: false, action: null },
  [DIALOG_KEYS.GROUP_LIMIT]: { open: false, isLoading: false, action: null },
}

const reducer = (state, action) => {
  const { type, payload } = action
  switch (type) {
    case 'OPEN_DIALOG':
      return {
        ...state,
        [payload.dialog]: {
          open: true,
          action: payload.action || null,
        },
      }
    case 'CLOSE_DIALOG':
      return {
        ...state,
        [payload]: {
          open: false,
          action: null,
        },
      }
    case 'SET_LOADING':
      return {
        ...state,
        [payload.dialog]: {
          ...state[payload.dialog],
          isLoading: payload.value,
        },
      }
    default:
      return state
  }
}

export const GroupDialogProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  const openDialog = (dialog, action = null) =>
    dispatch({ type: 'OPEN_DIALOG', payload: { dialog, action } })

  const closeDialog = (dialog) =>
    dispatch({ type: 'CLOSE_DIALOG', payload: dialog })

  const setLoading = (dialog, value) =>
    dispatch({ type: 'SET_LOADING', payload: { dialog, value } })

  return (
    <GroupDialogContext.Provider
      value={{
        dialogState: state,
        openDialog,
        closeDialog,
        setLoading,
      }}
    >
      {children}
    </GroupDialogContext.Provider>
  )
}

export const useGroupDialog = () => useContext(GroupDialogContext)
